import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'

import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import {
  ArrowRightCircleFill,
  CheckCircleFill,
  PencilFill,
  PlusCircleFill,
  Search,
  TrashFill,
  XCircleFill,
} from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import { CustomButton } from '../../../../CustomButton'
import { CustomSpinner } from '../../../../CustomSpinner'

import ProdutosService from '../../../../../services/database/ProdutosService'

import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

import EstruturasService from '../../../../../services/database/EstruturasService'
import { CustomIntegerInput } from '../../../../CustomDecimalInput'
import {
  Article,
  Center,
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
  StyledSearch,
} from '../../styles'

export const Composicao = forwardRef(
  ({ isVisible, onNext, productSku }, ref) => {
    const [composicoes, setComposicoes] = useState([])
    const [composicao, setComposicao] = useState({
      ID: null,
      SKU: null,
      DESCRICAO: '',
      QUANTIDADE: '',
      DESCRICAO_CONFIRMADA: false,
    })
    const [isLoadingComposicao, setIsLoadingComposicao] = useState(true)
    const [isSearchComposicaoLoading, setIsSearchComposicaoLoading] =
      useState(false)
    const [resultsComposicao, setResultsComposicao] = useState([])

    function handleAddComposicao(composicao) {
      function validateFields() {
        if (!composicao.DESCRICAO || !composicao.QUANTIDADE) {
          return false
        }

        return true
      }

      if (validateFields()) {
        if (!composicao.SKU) {
          return
        }

        setComposicoes((prevState) => [
          ...prevState,
          {
            ...composicao,
            SKU_ID: productSku,
            toAdd: true,
          },
        ])

        setComposicao({
          ID: null,
          SKU: null,
          DESCRICAO: '',
          QUANTIDADE: '',
          DESCRICAO_CONFIRMADA: false,
        })
      }
    }

    const handleSearchComposicao = useCallback(
      async (e) => {
        e.preventDefault()

        if (composicao.DESCRICAO.length === 0) {
          return
        }

        setIsSearchComposicaoLoading(true)

        try {
          const results = await ProdutosService.getAll(composicao.DESCRICAO)

          setResultsComposicao(!Array.isArray(results) ? [results] : results)
        } catch (err) {
          console.log(`Ocorreu um erro durante a pesquisa: ${err}`)
          toast.error(
            'Houve um erro com a pesquisa, tente novamente mais tarde!',
          )
        } finally {
          setIsSearchComposicaoLoading(false)
        }
      },
      [composicao.DESCRICAO],
    )

    function handleSelectKitComposicao(selectedComposicao) {
      setComposicao((prevState) => ({
        ...prevState,
        ID: selectedComposicao.CODPRODUTO,
        SKU: selectedComposicao.SKU,
        DESCRICAO: selectedComposicao.DESCRICAO,
        DESCRICAO_CONFIRMADA: true,
      }))

      setResultsComposicao([])
    }

    const loadComposicao = useCallback(async () => {
      try {
        setIsLoadingComposicao(true)

        const composicoesData =
          await EstruturasService.getItemsByProductSku(productSku)

        setComposicoes((prevState) => [
          ...composicoesData,
          ...prevState.filter((composicao) => composicao.toAdd),
        ])
      } catch (err) {
        sendErrorApiMessage(
          err,
          'Não foi possível buscar a composição do produto!',
        )
      } finally {
        setIsLoadingComposicao(false)
      }
    }, [productSku])

    useEffect(() => {
      if (isVisible) {
        setResultsComposicao([])
        setComposicao({
          ID: null,
          SKU: null,
          DESCRICAO: '',
          QUANTIDADE: '',
          DESCRICAO_CONFIRMADA: false,
        })

        loadComposicao()
      }
    }, [isVisible, loadComposicao])

    useImperativeHandle(
      ref,
      () => ({
        getComposicoes: () => {
          return composicoes
        },
      }),
      [composicoes],
    )

    if (!isVisible) {
      return null
    }

    return (
      <ContainerComponent ref={ref}>
        <div>
          <ContentComponent>
            {isLoadingComposicao ? (
              <Center
                style={{
                  justifyContent: 'flex-start',
                }}
              >
                <CustomSpinner />
                <p>Carregando Composição...</p>
              </Center>
            ) : (
              <>
                <h4>Composição</h4>

                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Estrutura do Item</Form.Label>

                      <div
                        style={{
                          display: 'flex',
                        }}
                      >
                        <Form.Control
                          type="text"
                          value={composicao.DESCRICAO}
                          placeholder="Pesquise e aperte ENTER"
                          onChange={(e) => {
                            if (e.target.value.length === 0) {
                              setResultsComposicao([])
                            }

                            setComposicao((prevState) => ({
                              ...prevState,
                              DESCRICAO: e.target.value,
                            }))
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.code === 'Enter' ||
                              e.code === 'NumpadEnter'
                            ) {
                              handleSearchComposicao(e)
                            }
                          }}
                        />

                        <CustomButton
                          color="#0d6efd"
                          onClick={handleSearchComposicao}
                          isLoading={isSearchComposicaoLoading}
                        >
                          <Search />
                        </CustomButton>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Quantidade</Form.Label>

                      <div
                        style={{
                          display: 'flex',
                        }}
                      >
                        <Form.Control
                          name="QUANTIDADE"
                          placeholder="Quantidade a ser adicionada"
                          type="number"
                          value={composicao.QUANTIDADE}
                          onChange={(e) =>
                            setComposicao((prevState) => ({
                              ...prevState,
                              QUANTIDADE: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              if (
                                composicao.DESCRICAO_CONFIRMADA &&
                                composicao.QUANTIDADE
                              ) {
                                handleAddComposicao(composicao)
                              }
                            }
                          }}
                        />

                        <CustomButton
                          color="#0d6efd"
                          onClick={() => handleAddComposicao(composicao)}
                          isDisabled={
                            !composicao.DESCRICAO_CONFIRMADA ||
                            !composicao.QUANTIDADE
                          }
                        >
                          <PlusCircleFill />
                        </CustomButton>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                {isSearchComposicaoLoading ? (
                  <div id="center-content">
                    <CustomSpinner size={40} />
                    <p>Carregando...</p>
                  </div>
                ) : (
                  <>
                    {resultsComposicao.length > 0 && (
                      <StyledSearch>
                        {resultsComposicao.map((result) => (
                          <Article
                            key={result.CODPRODUTO}
                            onClick={() => handleSelectKitComposicao(result)}
                          >
                            <p>
                              <strong>{result.SKU}</strong> | {result.DESCRICAO}
                            </p>
                          </Article>
                        ))}
                      </StyledSearch>
                    )}
                  </>
                )}

                <Row className="mb-3">
                  <Col>
                    {composicoes.length > 0 && (
                      <Table
                        striped
                        bordered
                        hover
                        responsive
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                width: 50,
                              }}
                            >
                              STATUS
                            </th>

                            <th
                              style={{
                                width: 50,
                              }}
                            >
                              SKU
                            </th>
                            <th>DESCRIÇÃO DO PRODUTO</th>
                            <th
                              style={{
                                width: 50,
                              }}
                            >
                              QUANTIDADE
                            </th>
                            <th
                              style={{
                                width: 50,
                              }}
                            >
                              AÇÃO
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {composicoes.map((comp, index) => (
                            <ComposicaoItem
                              index={index}
                              composicao={comp}
                              setComposicoes={setComposicoes}
                              loadComposicao={loadComposicao}
                            />
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </Col>
                </Row>
              </>
            )}
          </ContentComponent>

          <FooterComponent>
            <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
              <NextButton onClick={onNext}>
                <ArrowRightCircleFill
                  size={15}
                  color="white"
                />
              </NextButton>
            </OverlayTrigger>
          </FooterComponent>
        </div>
      </ContainerComponent>
    )
  },
)

export function ComposicaoItem({
  index,
  composicao,
  setComposicoes,
  loadComposicao,
}) {
  const [isEditMode, setIsEditMode] = useState(false)
  const [isDeleteComposicaoLoading, setIsDeleteComposicaoLoading] =
    useState(false)

  async function handleRemoveKitComposicao(comp) {
    if (comp.toAdd) {
      setComposicoes((prevState) =>
        prevState.filter((item) => item.SKU !== comp.SKU),
      )
    } else {
      setIsDeleteComposicaoLoading(true)

      try {
        await EstruturasService.delete(comp.ID)

        toast.success('Composição deletada com sucesso!')
        loadComposicao()
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível deletar a composição!')
      } finally {
        setIsDeleteComposicaoLoading(false)
      }
    }
  }

  return (
    <tr key={composicao.SKU}>
      <td>
        {composicao.toAdd ? (
          <OverlayTrigger overlay={<Tooltip>Salvo na memória</Tooltip>}>
            <XCircleFill
              color="#ea1010"
              size={20}
            />
          </OverlayTrigger>
        ) : (
          <OverlayTrigger overlay={<Tooltip>Salvo no banco de dados</Tooltip>}>
            <CheckCircleFill
              color="#04821d"
              size={20}
            />
          </OverlayTrigger>
        )}
      </td>
      <td>{composicao.SKU}</td>
      <td>{composicao.DESCRICAO}</td>
      <td>
        <CustomIntegerInput
          disabled={!isEditMode}
          value={composicao.QUANTIDADE}
          onChange={(e) => {
            setComposicoes((prevState) =>
              prevState.with(index, {
                ...prevState[index],
                QUANTIDADE: e.target.value,
              }),
            )
          }}
        />
      </td>
      <td>
        <div
          style={{
            display: 'flex',
            gap: 5,
          }}
        >
          {!isEditMode ? (
            <CustomButton
              noMargin
              color="#ff5733"
              onClick={() => {
                setIsEditMode(true)
              }}
            >
              <PencilFill />
            </CustomButton>
          ) : (
            <CustomButton
              noMargin
              color="#02a60a"
              onClick={() => {
                setIsEditMode(false)
              }}
            >
              <CheckCircleFill />
            </CustomButton>
          )}

          <CustomButton
            noMargin
            isLoading={isDeleteComposicaoLoading}
            color="#ea1010"
            onClick={() => {
              handleRemoveKitComposicao(composicao)
            }}
          >
            <TrashFill />
          </CustomButton>
        </div>
      </td>
    </tr>
  )
}
